export default {
  'app.settings.open': 'Open',
  'app.settings.close': 'Close',
  'unit.primary_name': 'Primary Name',
  'unit.secondary_name': 'Secondary Name',
  'unit.name': 'Name',
  'role.name': 'Name',
  'role.permissions': 'Permissions',
};
